import { UAParser } from './index';
import { parse } from '@utils/query-string';

/**
 * 判断微信小程序环境
 */
export const isInMiniProgram = () => {
  const { wxMiniProgram } = UAParser();
  return wxMiniProgram;
};

/** time（小时光）小程序 AppID，platform 与 App 一致（2/3） */
export const TIME_MINI_PROGRAM_APP_IDS = new Set(['wx7cdda4a530fa4d6b']);

/**
 * 无美囤原生分包（packageGoods 等）的宿主小程序，商详等须直接 webView 打开 H5
 * 可按 UA 中的 appId 继续补充
 */
export const THIRD_PARTY_MINI_PROGRAM_APP_IDS = new Set([
  ...TIME_MINI_PROGRAM_APP_IDS
]);

/** 微信 web-view UA 中常见片段：`miniProgram/wx{appid}` */
export const getMiniProgramAppIdFromUserAgent = (userAgent = window.navigator.userAgent) => {
  const m = /(m|M)iniProgram\/(wx[a-f0-9]{16})/i.exec(userAgent);
  if (process.env.NODE_ENV === 'development' && /(m|M)iniProgram/i.test(userAgent)) {
    console.log('[getMiniProgramAppIdFromUserAgent]', {
      regexMatched: m?.[0],
      appId: m?.[2]?.toLowerCase(),
      userAgent
    });
  }
  return m?.[2]?.toLowerCase();
};

/** 非美囤宿主小程序（含小时光）；UA 无 appId 时按三方处理，避免走原生再降级 */
export const isThirdPartyMiniProgram = () => {
  if (!isInMiniProgram()) {
    return false;
  }
  const appId = getMiniProgramAppIdFromUserAgent();
  if (!appId) {
    return true;
  }
  return THIRD_PARTY_MINI_PROGRAM_APP_IDS.has(appId);
};

/** 当前宿主是否可走美囤小程序原生分包 */
export const canUseMeitunNativeMiniRoute = () =>
  isInMiniProgram() && !isThirdPartyMiniProgram();

/** time 小程序 web-view（UA 含对应 appid） */
export const isInTimeMiniProgram = () => {
  const {userAgent} = window.navigator;
  if (
    process.env.NODE_ENV === 'development' &&
    /(m|M)iniProgram/i.test(userAgent)
  ) {
    console.log('[isInTimeMiniProgram] UA 含 miniProgram 字样', {
      isInMiniProgram: isInMiniProgram(),
      userAgent
    });
  }
  if (!isInMiniProgram()) {
    return false;
  }
  const appId = getMiniProgramAppIdFromUserAgent(userAgent);
  return !!appId && TIME_MINI_PROGRAM_APP_IDS.has(appId);
};

/**
 * 判断星喜环境
 */
export const isInFosun = () => {
  const fosun = parse(window.location.search)?.fosun || '';
  return fosun == 1;
};

/**
 * 判断微信浏览器
 */
export const isInWechat = () => {
  const { Wechat } = UAParser();
  return Wechat;
};
